<template>
  <div class="container">
    <el-carousel height="40rem" direction="vertical">
      <el-carousel-item class="feature" :key="index" v-for="(page, index) in pages">
        <div class="top">
          <p class="keyword" v-html="page.label" />
          <div class="border" />
        </div>
        <div class="bottom">
          <div class="line" :key="index" v-for="(line, index) in page.children">
            <div class="image">
              <img class="topic" :key="index" :src="line.topic" />
            </div>
            <div class="content">
              <p class="label" v-html="line.label" />
              <p class="detail" v-html="line.detail" />
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'scene',
  data() {
    return {
      pages: [
        {
          prop: 'security',
          label: this.$t('Home.feature.security.label'),
          children: [
            {
              prop: 'system',
              image: 'os.png',
              label: this.$t('Home.feature.security.system.label'),
              detail: this.$t('Home.feature.security.system.details')
            },
            {
              prop: 'data',
              image: 'versions.png',
              label: this.$t('Home.feature.security.data.label'),
              detail: this.$t('Home.feature.security.data.details')
            },
            {
              prop: 'service',
              image: 'password.png',
              label: this.$t('Home.feature.security.service.label'),
              detail: this.$t('Home.feature.security.service.details')
            }
          ]
        },
        {
          prop: 'privacy',
          label: this.$t('Home.feature.privacy.label'),
          children: [
            {
              prop: 'system',
              image: 'business.svg',
              label: this.$t('Home.feature.privacy.system.label'),
              detail: this.$t('Home.feature.privacy.system.details')
            },
            {
              prop: 'data',
              image: 'work.svg',
              label: this.$t('Home.feature.privacy.data.label'),
              detail: this.$t('Home.feature.privacy.data.details')
            },
            {
              prop: 'service',
              image: 'key.svg',
              label: this.$t('Home.feature.privacy.service.label'),
              detail: this.$t('Home.feature.privacy.service.details')
            }
          ]
        },
        {
          prop: 'hosted',
          label: this.$t('Home.feature.hosted.label'),
          children: [
            {
              prop: 'system',
              image: 'space.svg',
              label: this.$t('Home.feature.hosted.system.label'),
              detail: this.$t('Home.feature.hosted.system.details')
            },
            {
              prop: 'data',
              image: 'account.svg',
              label: this.$t('Home.feature.hosted.data.label'),
              detail: this.$t('Home.feature.hosted.data.details')
            },
            {
              prop: 'service',
              image: 'model.svg',
              label: this.$t('Home.feature.hosted.service.label'),
              detail: this.$t('Home.feature.hosted.service.details')
            }
          ]
        },
        {
          prop: 'extension',
          label: this.$t('Home.feature.extension.label'),
          children: [
            {
              prop: 'system',
              image: 'extension.svg',
              label: this.$t('Home.feature.extension.system.label'),
              detail: this.$t('Home.feature.extension.system.details')
            },
            {
              prop: 'data',
              image: 'link.svg',
              label: this.$t('Home.feature.extension.data.label'),
              detail: this.$t('Home.feature.extension.data.details')
            },
            {
              prop: 'service',
              image: 'more.svg',
              label: this.$t('Home.feature.extension.service.label'),
              detail: this.$t('Home.feature.extension.service.details')
            }
          ]
        }
      ]
    }
  },
  created() {
    this.pages.forEach(obj => {
      // exp: extension
      if (obj.children) {
        obj.children.forEach(o => {
          // exp: extension.system
          o.topic = require('@/assets/' + o.image)
        })
      }
    })
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 50rem;
}

.feature {
  display: flex;
  flex-direction: column;
}

.feature .top {
  width: 100%;
  height: 6rem;
  padding: 3rem 0 0;

  display: flex;
  flex-direction: column;
  align-items: center;
}
.feature .bottom {
  width: 100%;
  height: calc(100% - 6rem);
  padding: 0 3rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
}

.top .keyword {
  font-size: 3.25rem;
  line-height: 4rem;
}
.top .border {
  width: 12rem;
  margin-top: 0.6rem;
  border: 0.1rem solid #161616;
}

.bottom .line {
  padding-bottom: 1rem;

  display: flex;
  flex-direction: row;
}

.line .image {
  width: 7rem;
  height: 7rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.line .content {
  display: flex;
  flex-direction: column;
}

.content .label {
  font-size: 1.6rem;
  padding-bottom: 0.4rem;
}
.content .detail {
  font-size: 1rem;
  line-height: 1.6rem;
  padding-left: 0.6rem;
}

.image .topic {
  width: 6rem;
  height: 6rem;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
